var render = function render(){var _vm=this,_c=_vm._self._c;return _c('object',{staticClass:"pdfPreview",style:({ height: _vm.documentHeight ? _vm.documentHeight : '1194px' }),attrs:{"data":_vm.document,"type":"application/pdf"}})
}
var staticRenderFns = []

export { render, staticRenderFns }